import { useLazyQuery, useMutation } from "@apollo/client/react";
import { gql } from "@apollo/client";
import toast from "react-hot-toast";
import { AuthorizationCheckRequired, eventBus, PmStore } from "@/state";

const ApplicationCountQuery = gql`
    query applicationCount($organizationId: UUID!) {
       applicationCount(organizationId: $organizationId) 
  }
`;

const AssetCountQuery = gql`
    query assetCount($organizationId: UUID!) {
       assetCount(organizationId: $organizationId) 
  }
`;

const TenantCountQuery = gql`
    query tenantCount($organizationId: UUID!) {
       tenantCount(organizationId: $organizationId) 
  }
`;



var ApplicationCountByStatusQuery = gql`
     query applicationCountsByStatus($organizationId: UUID!) {
       applicationCountsByStatus(organizationId: $organizationId, onlyActive: false) 
       {
        status
        statusId
        count
       
       }
  }
`;





export function useMetricActions() {
    const state = PmStore();
    const [apiGetApplicationCount] = useLazyQuery(ApplicationCountQuery);
    const [apiGetAssetCount] = useLazyQuery(AssetCountQuery);
    const [apiGetTenantCount] = useLazyQuery(TenantCountQuery);
    const [apiGetApplicationCountByStatus] = useLazyQuery(ApplicationCountByStatusQuery);


    async function GetApplicationCount() {
        var  organizationId = state?.selectedOrganization?.id as string
        try {
            let result = await apiGetApplicationCount({ variables:  {organizationId}}) as any;
            return result.data.applicationCount as any;
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await GetApplicationCount();
            }
            else {
                toast.error("Api Error, Unable to get tenant count");
                throw error;
            }
        }
    }
   

    async function GetAssetCount() {
        var  organizationId = state?.selectedOrganization?.id as string
        try {
            let result = await apiGetAssetCount({ variables:  {organizationId}}) as any;
            return result.data.assetCount as any;
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await GetAssetCount();
            }
            else {
                toast.error("Api Error, Unable to get tenant count");
                throw error;
            }
        }

    }

    async function GetTenantCount() {


        var  organizationId = state?.selectedOrganization?.id as string
        try {
            let result = await apiGetTenantCount({ variables:  {organizationId}}) as any;
            return result.data.tenantCount as any;
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await apiGetTenantCount();
            }
            else {
                toast.error("Api Error, Unable to get tenant count");
                throw error;
            }
        }

    }

    async function GetApplicationCountByStatus(test) {

        var  organizationId = state?.selectedOrganization?.id as string
        try {
            let result = await apiGetApplicationCountByStatus({ variables:  {organizationId}}) as any;
            return result.data.applicationCountsByStatus as any;
        }
        catch (error) {
            if (error?.name == "AbortError") {
               return await GetApplicationCountByStatus(test);
            }
            else {
                toast.error("Api Error, Unable to get application status count");
                throw error;
            }
        }
    }

    
    return {
        GetApplicationCount,
        GetAssetCount,
        GetTenantCount,
        GetApplicationCountByStatus
    };
}




